<template>
    <div>
    <span
        v-on:click="showModal"
        :class="[btnInverted ? btnThemeInverted : btnTheme ]"

    >
            {{  btnName }}
    </span>
        <div v-if="showConfirm" class="modal-mask" @click="closeModal">
            <div class="modal-wrapper" @click.stop>
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header">
                            {{ header }}
                          <span class="pull-right" @click="closeModal" style="cursor:pointer;">x</span>
                        </slot>
                    </div>
                    <div class="modal-body">
                        <slot name="body">
                          <div>
                            <p>Please confirm that your name and email address are correct, then click the "Send Message and Close" button.</p>
                            <p>A representative will get back to you as soon as possible.</p>
                            <ul v-for="(value,name) in fullName">
                              <li>Your {{ name.charAt(0).toUpperCase() + name.slice(1) }} : {{ value }}</li>
                            </ul>
                          </div>
                            <div v-html="jurisdictions"></div>
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button
                                type="button"
                                @click.prevent="sendMessage"
                                class="modal-default-button btn btn-primary"
                            >
                                Send Message and Close
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
  import axios from 'axios'
  import ConfirmModal from "./ConfirmModal";

  export default {
    components: {ConfirmModal},
    props: {
      header: {
        required: true
      },
      userDetails: {
        type: Object
      },
      jurisdictions: String,
      link: String,
      btnName: String,
      btnInverted: '',
    },
    data() {
      return {
        showConfirm: false,
        fullName: this.userDetails,
        btnTheme: 'btn btn-blue btn-lauren margin-top-15 width-340 padding-left-20 padding-right-20',
        btnThemeInverted: 'btn btn-lauren btn-blue btn-inverted width-300'
      }
    },
    methods: {
      showModal() {
        this.showConfirm = true
      },
      closeModal() {
        this.showConfirm = false
      },
      sendMessage() {
        axios.get('learn-more')
            .then(response => {
              alert(response.data.status)
              return Promise.resolve()
            })
        this.closeModal()
      }
    }
  }
</script>
